import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useQuery, fetchPostQuery } from '/src/api';
import {
    useStoreConfigContext,
    useModalsContext,
    useAuthContext,
    useCartContext,
} from '/src/providers';
import { Form, Loader } from '/src/components';
import { getCookie, setCookie, removeCookie } from '/src/utils';
import { VIP } from '/src/consts';
import graphQLQueries from './graph-ql-queries';
import * as styles from './styles.scss';

import cash from './images/bwfo-cash.png';

const VipBlock = ({ formatPrice, cash, className, translate }) => (
    <div className={`${styles.vip}${className ? ` ${className}` : ''}`}>
        <div className={styles.price}>
            {formatPrice(cash)}
        </div>
        <div className={styles.earn}
             dangerouslySetInnerHTML={{ __html: translate(`You will earn %1 in BWFO Cash %2 by purchasing this product.`, formatPrice(cash), `<span class="${styles.yel}">${translate('as a VIP member')}</span>`)}}
        />
    </div>
);

const BWFOCash = ({
    className,
    isLoadingPoints,
    data,
    isProductPage,
    isCheckout,
    setIsGuestContinue,
}) => {
    const { translate, formatPrice } = useStoreConfigContext();
    const { isAuth } = useAuthContext();
    const { showModal, MODALS_TYPES } = useModalsContext();
    const [customer, setCustomer] = useState({ isVip: !!getCookie(VIP), email: '' });
    const { isVip, email } = customer;
    const [isWaiting, setIsWaiting] = useState(false);

    const isLoading = isLoadingPoints || isWaiting;
    const { bwfo_cash, vip_bwfo_cash } = data || {};

    const handleSetIsVip = isVip => {
        setCustomer({ ...customer, isVip });

        if (isVip) {
            setCookie(VIP, isVip, 1);
        } else {
            removeCookie(VIP);
        }
    };

    const handleSetCustomerIsVip = isVip => {
        setIsWaiting(true);
        fetchPostQuery({
            query: graphQLQueries.setVipStatusOpt,
            variables: {
                input: {
                    email,
                    value: isVip
                }
            }
        }).then(() => {
            setCustomer({ ...customer, isVip });
            setIsWaiting(false);
        }).catch(errors => {
            showModal(MODALS_TYPES.ERROR, { errors });
            setIsWaiting(false);
        })
    };

    const getCustomerData = () => {
        if (isAuth) {
            setIsWaiting(true);
            fetchPostQuery({
                query: graphQLQueries.customer
            }).then(({ customer: { custom_attributes, email } }) => {
                const { selected_options } = custom_attributes?.find(({ code }) => code === 'vip_status') || {};
                const isVip = !!selected_options ? !!+selected_options[0]?.value : false;

                setCustomer({
                    isVip,
                    email
                });
                setIsWaiting(false);
            }).catch(() => {
                setIsWaiting(false);
            });
        } else if (email) {
            setCustomer({ isVip: false, email: '' })
        }
    };

    useEffect(() => {
        if (isProductPage) {
            getCustomerData();
        }
    }, []);

    useEffect(() => {
        if (!isProductPage) {
            getCustomerData();
        }
    },  [isAuth]);

    return (
        <div className={`${styles.rel}${className ? ` ${className}` : ''}`}>
            <div className={styles.wrapper}>
                <Loader isLoading={isLoading}>
                    <div className={styles.cash}>
                        {isVip ? `${translate('Earn')} ` : `${translate('Earn up to')} `}
                        <span className={isVip ? styles.got: styles.def}>
                            {formatPrice(vip_bwfo_cash)}
                        </span>
                        {` BWFO Cash!`}
                    </div>
                </Loader>
                <button className={styles.close} />
                <div className={`${styles.hover} ${isProductPage ? styles.left : styles.right}`}>
                    <Loader isLoading={isLoading}>
                        <div className={styles.modal}>
                            <div className={styles.head}>
                                <img
                                    className={styles.image}
                                    src={cash}
                                    alt="bwfo cash"
                                />
                                <div className={styles.text}>
                                    {translate('BWFO Cash is a loyalty reward which allows you to earn credit to save or use towards your next order')}
                                </div>
                                <Link className={styles.link} to="/reward-points.html" target="_blank">
                                    {translate('Learn more here')}
                                </Link>
                                <div className={styles.reward}>
                                    {translate('Your reward now')}
                                </div>
                                {
                                    isVip
                                    ? <VipBlock formatPrice={formatPrice} cash={vip_bwfo_cash} translate={translate} />
                                    : <div
                                            className={styles.text}
                                            dangerouslySetInnerHTML={{
                                                __html: translate(`As a non VIP Member, you will only earn %1 in BWFO Cash when you purchase this product.`, `<span class="${styles.dune}">${translate(`1% or %1`, formatPrice(bwfo_cash))}</span>`)
                                            }}
                                        />
                                }
                            </div>
                            {
                                (!isVip || !(isAuth && isVip)) &&
                                <div className={styles.body}>
                                    <div className={styles.become}>
                                        {
                                            !(isAuth && isVip) &&
                                            <div>
                                                <div className={styles.member}>
                                                    {translate('Become VIP Member for FREE')}
                                                </div>
                                                <div className={styles.text}>
                                                    {translate('We offer our VIP members an exclusive 4% in BWFO Cash, along with many other benefits.')}
                                                </div>
                                            </div>
                                        }
                                        {
                                            !(isAuth && isVip) &&
                                            <div>
                                                <Form.Switch
                                                    onChange={
                                                        () => isVip
                                                            ? isAuth ? handleSetCustomerIsVip(false) : handleSetIsVip(false)
                                                            : showModal(MODALS_TYPES.VIP, {
                                                                isCheckout,
                                                                setIsGuestContinue,
                                                                email,
                                                                setIsVip: isAuth ? isVip => setCustomer({
                                                                    ...customer,
                                                                    isVip
                                                                }) : handleSetIsVip
                                                            })
                                                    }
                                                    checked={isVip}
                                                    disabled={isLoading}
                                                />
                                            </div>
                                        }
                                    </div>
                                    {
                                        !isVip &&
                                        <VipBlock
                                            className={styles.out}
                                            formatPrice={formatPrice}
                                            cash={vip_bwfo_cash}
                                            translate={translate}
                                        />
                                    }
                                    {
                                        !isVip &&
                                        <div
                                            className={styles.text}
                                        >
                                            {`${translate('If you are already a VIP Member')}, `}
                                            <button
                                                className={styles.link}
                                                disabled={isLoading}
                                                onClick={() => showModal(MODALS_TYPES.ACCOUNT)}
                                            >
                                                {translate('Sign In')}
                                            </button>
                                            {` ${translate('to earn these rewards now')}`}
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </Loader>
                </div>
            </div>
        </div>
    );
};

const BWFOCashProduct = ({ product_uid }) => {
    const {
        data,
        isLoading: isLoadingPoints,
        runQuery,
    } = useQuery({
        query: graphQLQueries.getProductRewardPoints,
        queryKey: ['getProductRewardPoints'],
        isMethodPost: true,
    });

    useEffect(() => {
        if (product_uid) {
            runQuery({
                variables: {
                    product_uid,
                }
            })
        }
    }, [product_uid]);

    return !!data &&
        <BWFOCash
            className={styles.product}
            data={data}
            isLoadingPoints={isLoadingPoints}
            isProductPage={true}
        />
};

const BWFOCashCart = ({ isCheckout, setIsGuestContinue }) => {
    const {
        cart: { cart_points },
        isLoadingCart,
    } = useCartContext();

    return !!cart_points &&
        <BWFOCash
            className={styles.cart}
            data={cart_points}
            isLoadingPoints={isLoadingCart}
            isProductPage={false}
            isCheckout={isCheckout}
            setIsGuestContinue={setIsGuestContinue}
        />
};

export  {
    BWFOCashProduct,
    BWFOCashCart,
};
